<template>
  <div Id="Lang">
    <el-select v-model="stateLang" :size="size" placeholder="请选择" @visible-change="changeLang">
      <el-option v-for="item in langs" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  name: "changeLang",
  components: {},
  data() {
    return {
      langs: this.$enumInfo.languages, // ,{ label: "简中", value: "zh" },
      stateLang: this.$store.state.lang,
      oldVal: ''
    };
  },
  props: {
    size: {
      typeof: "string",
      default: "mini"
    }
  },
  mounted() {},
  watch: {

  },
  inject: ['reload'],
  methods: {
    changeLang(e) {
      let that = this
      var newVal
      var oldVal
      if (e) {
        this.oldVal = this.stateLang
      }
      if (!e) {
        // 下拉关闭
        newVal = this.stateLang
        oldVal = this.oldVal
        let langName = this.langs
        langName = langName.filter(function(res) {
          var value
          if (res.value == newVal) {
            value = res.label
          }
          return value
        })
        if (newVal != oldVal) {
          this.$confirm(`<div style="padding: 0 24px;">`+this.$t('base.changeto')+` ` + langName[0].label + `</div>`, this.$t('title.changeLanguage'), {
              // showConfirmButton: true ,
              dangerouslyUseHTMLString: true,
              confirmButtonText: this.$t('base.change'),
              cancelButtonText: this.$t('base.cancel'),
              lockScroll: false
            })
            .then(() => {
              that.stateLang = newVal
              let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.NODE_DOMAIN;
              this.$i18n.locale = newVal;
              this.$store.state.lang = newVal;
              // this.$store.state.webConfig.lag = e;
              this.$cookie.set('CardLang', newVal, {
                // expires: this.$store.state.exdays, 
                domain
              });
              that.reload()

            })
            .catch(() => {
              that.stateLang = oldVal
            })

        }

      }

    }

  },
};

</script>
<style scoped>
#Lang {
  width: auto;
  line-height: 1.4;
  /* margin: 0 20px; */
}

</style>



// WEBPACK FOOTER //
// src/components/change-lang.vue